/**

 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

/**
 * @param {string} phone
 * @returns {Boolean}
 */
export function validPhone(phone) {
  const reg = /^1[3-9]\d{9}$/
  return reg.test(phone)
}

/**
 * @param {string} idNo (身份证)
 * @returns {Boolean}
 */
export function validIdNo(idNo) {
  const reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
  return reg.test(idNo)
}

/**
 * @param {string} 正整数不含0
 * @returns {Boolean}
 */
export function validNum(num) {
  const reg = /^[0-9]*[1-9][0-9]*$/
  return reg.test(num)
}

/**
 * @param {string} 正整数含0
 * @returns {Boolean}
 */
export function validNum0(num) {
  const reg = /^([1-9]\d*|[0]{1,1})$/
  return reg.test(num)
}

/**
 * @param {string} 正数含0，保留两位小数
 * @returns {Boolean}
 */
export function validNum0Decimal2(num) {
  const reg = /^(([1-9]{1}\d*)|([0]{1}))(\.(\d){1,2})?$/
  return reg.test(num)
}
/**
 * @param {string} 实数，保留两位小数
 * @returns {Boolean}
 */
export function validNumDecimal2(num) {
  const reg = /^(\-)?\d+(\.\d{1,2})?$/
  return reg.test(num)
}
/**
 * @param {string} 正数不含0，保留两位小数
 * @returns {Boolean}
 */
export function validNumMoreDecimal2(num) {
  const reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/
  return reg.test(num)
}
/**
 * @param {string} 100的整数倍
 * @returns {Boolean}
 */
export function validNum100(num) {
  const reg = /^[1-9]\d*00$/
  return reg.test(num)
}
